/**
 * Dozwolony identyfikator gminy — lustro backendowego TENANT_ID_REGEX
 * (api/src/modules/tenant/tenant.funcs.ts). Zmieniać razem.
 */
export const TENANT_ID_PATTERN = /^[a-zA-Z0-9_]+$/;
export const TENANT_ID_PATTERN_MESSAGE = "Tylko litery, cyfry i podkreślenia";

/** Identyfikator prawdziwej gminy — superadmin ma w JWT tenantId "public". */
export const isRealTenantId = (id?: string | null): id is string => !!id && id !== "public";

/** Identyfikator gminy używany w URL i nazwie schematu tenantowego. */
export function tenantSlug(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ł/g, "l")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");
}
